import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot ,Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoggedinGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(){
  	//return true;
    return this.checkCondition();
  }

  checkCondition():boolean{
    let value = localStorage.getItem('token');
    if(!value){
    	this.router.navigate(['/login']);
      return false;
  	}
    
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/loggedin/loggedin.guard.ts